
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';

export default defineComponent({
    name: "PriceTendencyLegend",
    props: {
    },
    setup(props) {
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const priceTendencies = computed(() => {
            return getConfig('priceTendencyLegend');
        });

        const getAdditionalPriceTendencyForMobile = (priceTendency) => {
            if(priceTendency === 'low') {
                return '(L3)';
            } else if(priceTendency === 'rather-low') {
                return '(L2)';
            } else if(priceTendency === 'normal') {
                return '(L1)';
            } else {
                return;
            }
        }

        return {
            priceTendencies,
            getAdditionalPriceTendencyForMobile,
            isMobile,
            translate
        }
    }
})
